import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { useQuery } from "@tanstack/react-query";
import { AliasProduct } from "../types/AliasProduct";
import qr from "query-string";
import { Pagination, PaginationResponse } from "@/core/common/types";

export const GET_ALIAS_PRODUCTS_FETCH_KEY = "GET_ALIAS_PRODUCTS_FETCH_KEY";

type GetAliasProductsParams = {
  showDisabled?: boolean;
  searchTerm?: string;
  zoneIds?: string[] | string;
} & Partial<Pagination>;

export const getAliasProducts = async (
  zoneIds?: string[] | string,
  showDisabled = false,
  page = 1,
  pageSize = 10,
  searchTerm?: string,
) => {
  const params = qr.stringify({
    zoneIds,
    showDisabled,
    page,
    pageSize,
    searchTerm,
  });
  const response = await fetcher.get(`${API.GESLUB}/alias-product?${params}`);
  return response.data;
};

export const useGetAliasProducts = ({
  page,
  pageSize,
  showDisabled,
  searchTerm,
  zoneIds,
}: GetAliasProductsParams = {}) => {
  const { data, error, isPending, refetch } = useQuery<
    PaginationResponse<AliasProduct>
  >({
    placeholderData: (previousData) => previousData,
    queryKey: [
      GET_ALIAS_PRODUCTS_FETCH_KEY,
      zoneIds,
      showDisabled,
      page,
      pageSize,
      searchTerm,
    ],
    queryFn: async () =>
      getAliasProducts(zoneIds, showDisabled, page, pageSize, searchTerm),
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination,
    error,
    isPending,
    refetch,
  };
};
